<template>
  <div class='profile-text'>
    <span> <strong style="font-size: 1.2rem">{{ title }}</strong></span>
    
    <!-- Display -->
    <span v-if='!editing'>
      <slot name='content'>
        <div v-if="chiplist">
          <v-chip  label outline
            v-for="data in content"
            :key='data'>
              {{data}}
          </v-chip>
        </div>
        <span v-else-if="date">{{content |  moment("DD/MM/YYYY")}}</span>
        <span v-else-if="showbykey">{{content[showbykey]}}</span>
        <span v-else>{{content}}</span>
      </slot>
    </span>

    <!-- Edit -->
    <div v-else>
      <div v-if="inputType == 'simpletext'">
        <v-text-field
          id="testing"
          v-model="content"
          :mask='mask'
        ></v-text-field>
      </div>
       <div v-else-if="inputType == 'multilinetext'">
        <v-textarea
          id="testing"
          v-model="content"
          :counter='1200'
        ></v-textarea>
      </div>
      <div v-else-if="inputType == 'multiselect'">
        <v-select
          :label="title"
          :items="selectOptions"
          multiple
          max-height="400"

          v-model="content"
        ></v-select>
      </div> <div v-else-if="inputType == 'multiunidade'">
        <v-select
          :label="title"
          :items="selectOptions"
          item-text="name"
          item-value="name"
          multiple
          max-height="400"
          v-model="content"
        ></v-select>
      </div>

      <div v-else-if="inputType == 'mediadorselect'">
        <v-select
          :label="title"
          :items="selectOptions"
          max-height="400"
          item-text="full_name"
          item-value="username"
          return-object
          v-model="newValue"
        ></v-select>
      </div> 
                

      <div v-else-if="inputType == 'datepicker'">
        <v-menu
        ref="mydatemenu"
        lazy
        :close-on-content-click="false"
        v-model="datemenu"
        transition="scale-transition"
        offset-y
        full-width
        :nudge-right="40"
        min-width="290px"
        :return-value.sync="content"
      >
        <v-text-field
          slot="activator"
          v-model="$moment(content).format('DD/MM/YYYY')"
          prepend-icon="event"
          readonly
        ></v-text-field>
        <v-date-picker v-model="content" locale='pt-br' no-title scrollable>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="datemenu = false">Cancelar</v-btn>
          <v-btn flat color="primary" @click="$refs.mydatemenu.save(content)">OK</v-btn>
        </v-date-picker>
      </v-menu>
      </div>

    </div>



    <v-divider v-if='!last'></v-divider>
    </div>
</template>

<script>
export default {
  data: () => {
    return {
      datemenu: false,
      newValue: null
    }
  },
  props: {
    title: {
      default: 'title'
    },
    chiplist: {
      default: false,
      type: Boolean
    },
    last: {
      type: Boolean,
      default: false
    },
    editing: {
      type: Boolean,
      default: false
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    date: {
      type: Boolean,
      default: false
    },
    inputType: {
      default: 'simpletext'
    },
    mask: {
      type: String
    },
    selectOptions: {
    },
    value: {

    },
    showbykey: {

    }
  },
  computed: {
    content: {
      get () {
        if (this.newValue) {
          return this.newValue
        }
        return this.value
      },
      set (value) {
        this.newValue = value
      }
    }
  },
  methods: {
    emitvalue () {
      this.$emit('input', this.value)
    }
  },
  watch: {
    newValue (val, oldval) {
      this.$emit('input', val)
    }
  },
  mounted () {
    this.newValue = this.value
  }
}
</script>

<style lang="scss" scoped>

.profile-text{
  margin-top: 1rem;
  h3 { 
    margin-bottom: 1rem;
  }
  strong {
    margin-bottom: 1rem;
  }
  p {
    margin-left: 2rem;
    margin-right: 2rem;
  }
  >div {
    margin-left: 2rem;
    margin-right: 2rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/reusable/ProfileText.vue